import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const checkCancellationAction = {
    ...operations,
    ...selectors,
};

export {
    checkCancellationAction,
};
export default {
    [namespace]: reducer,
};
